module.exports = __webpack_public_path__ + "media/images/common/ico-caution-49cfb27e1e040f8a37ba7b72fd6dbcb3.svg";